module.exports = __webpack_public_path__ + "img/S310.c872faed.jpg";